// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1LHxI","head":"ProcedureTableInfo_head__3Pa4F"};